import { useEffect, useState } from 'react';
import AllotmentsHotelSelector from '../Allotments/Partials/AllotmentsHotelSelector';
import NightRatesHotelEditor from './Partials/NightRatesHotelEditor';
import { formatHotelResult } from '../Allotments/Partials/allotmentsUtils';
import { getHotel } from 'api/node/hotels';
import { useAsync } from 'react-async';
import { KoobListPageLayout } from '@koob/ui';
import FilterHotels from 'components/FilterHotels';
import LocationAwareSearch from 'components/LocationAwareSearch';
import { Container } from 'ui';

export default function NightRates() {
  const [hotel, setHotel] = useState(null);

  const { data: hotelData } = useAsync({
    promiseFn: getHotel,
    hotelId: hotel?.id,
    skip: !hotel?.id,
    watchFn: (prev, next) => prev.hotelId !== next.hotelId,
  });

  useEffect(() => {
    if (hotelData) {
      setHotel(formatHotelResult(hotelData.data));
    }
  }, [hotelData]);

  return (
    <Container variant="main" size="full">
      <KoobListPageLayout
        width="wide"
        search={<LocationAwareSearch name="search" />}
        filters={<FilterHotels />}
      >
        <div className="pb-16 flex-col space-y-5">
          <AllotmentsHotelSelector
            hotel={hotel}
            setHotel={setHotel}
            kind="nightRates"
          />

          {hotel && (
            <NightRatesHotelEditor
              hotel={hotel}
              currency={hotelData?.data?.currency?.toUpperCase()}
              canUpdateHotel={hotelData?.data?.canUpdateHotel ?? false}
            />
          )}
        </div>
      </KoobListPageLayout>
    </Container>
  );
}
